export default {"src":"/_next/static/media/hassleFreeProcess.65184220.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};